import { FocusLayerSizeV2 } from "@volkswagen-onehub/layer-manager";
import React, { useContext, useEffect } from "react";
import { isReturnVisitor } from "../Cookies";
import { Search } from "../Filtering/modal";
import { LayerContext, useFocusLayer } from "../Layers";
import { UserLocationContext } from "../UserLocation/UserLocationContext";

export const usePromptWelcome = () => {
  const { closeLayer } = useContext(LayerContext);
  const { postalChecked, postalCode } = useContext(UserLocationContext);
  const hasExistingPostalCode = !!postalCode?.length;
  const isReturning = isReturnVisitor();

  const openWelcomeLayer = useFocusLayer('welcome-layer', {
    size: FocusLayerSizeV2.B,
    onClose: () => closeLayer('welcome-layer'),
    userCloseable: hasExistingPostalCode
  });

  const shouldPrompt = postalChecked && (!isReturning || !hasExistingPostalCode);

  useEffect(() => {
    if (shouldPrompt) {
      openWelcomeLayer((close) => <Search close={close} />)
    }
  }, [shouldPrompt]);
};